import { defineStore } from 'pinia'

import { useSearchOptionsStore } from '@/stores/SearchOptionsStore'
import { useSelectedFiltersStore } from '@/stores/SelectedFiltersStore'

export const useCandidateBoardStore = defineStore('CandidateBoard', {
    state: () => ({
        profiles: [],
    }),
    getters: {
        isAddedToBoard: (state) => {
            return (profileId) => state.profiles.map((profile) => profile.id).includes(profileId);
        },
        getProfiles: (state) => {
            return () => state.profiles;
        },
        getProfileIds: (state) => {
            return () => state.profiles.map((profile) => profile.id);
        },
        getProfileCount: (state) => {
            return () => state.profiles.length;
        },
        getProfileCriterias: (state) => {
            return () => state.profiles.map((profile) => {
                return {
                    id: profile.id,
                    terms: profile.activeTerms,
                    filters: profile.activeFilters,
                }
            });
        },
    },
    actions: {
        addToBoard(profile) {
            const SearchOptionsStore = useSearchOptionsStore();
            const SelectedFiltersStore = useSelectedFiltersStore();

            let activeTerms = SearchOptionsStore.getActiveFilters();
            let activeFilters = SelectedFiltersStore.getActiveFiltersWithName();

            profile.activeTerms = activeTerms.filter(filter => profile.scores.map(score => score.type_id).includes(filter.type + '_' + filter.id));
            profile.activeFilters = activeFilters;

            this.profiles.push(profile);
        },
        removeFromBoard(profileId) {
            this.profiles.splice(this.profiles.map((profile) => profile.id).indexOf(profileId), 1)
        },
    },
})